/**
 * UserEmptyState — contextual empty state for the users table.
 * @param {{ type: 'no-data' | 'no-results', onAddUser?: () => void, onClearFilters?: () => void }} props
 */
const UserEmptyState = ({ type, onAddUser, onClearFilters }) => {
  if (type === 'no-data') {
    return (
      <div className="up-empty">
        <div className="up-empty__icon-wrap">
          <svg className="up-icon-xl up-empty__icon" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128H5.228A2.25 2.25 0 013 16.878v-.003c0-1.113.285-2.16.786-3.07M15 19.128H5.228M12 9.75a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
          </svg>
        </div>
        <h3 className="up-empty__title">No users yet</h3>
        <p className="up-empty__text">
          Get started by adding your first user to this campus. Users will appear here once added.
        </p>
        {onAddUser ? (
          <button
            type="button"
            onClick={onAddUser}
            className="up-btn up-btn--primary"
          >
            <svg className="up-icon-md" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            Add User
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <div className="up-empty">
      <div className="up-empty__icon-wrap">
        <svg className="up-icon-xl up-empty__icon" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
        </svg>
      </div>
      <h3 className="up-empty__title">No results found</h3>
      <p className="up-empty__text">
        No users match your current search or filter criteria. Try adjusting your search terms or clearing filters.
      </p>
      {onClearFilters ? (
        <button
          type="button"
          onClick={onClearFilters}
          className="up-btn up-btn--outline"
        >
          <svg className="up-icon-md" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
          Clear All Filters
        </button>
      ) : null}
    </div>
  );
};

export default UserEmptyState;
